module.exports = __webpack_public_path__ + "static/media/laptop2-min.9a5948e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/laptop2-min.png
// module id = 254
// module chunks = 0